module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "nist-lam--dataset-cover.2118f7e0.png";